import React from "react";
import { Flex } from "../Flex";
import { Image, ImageProps } from "../Image/Image";

interface Props {
  images?: ImageProps[];
  width: string | number;
}

export const ImagesContainer: React.FC<Props> = ({ images, width }) => {
  return (
    <Flex justifyContent="center" flexDirection={["column", "row"]}>
      {images && images.map(image => <Image px={3} key={image.alt} data-testid="image" width={width} {...image} />)}
    </Flex>
  );
};
